import React from "react";
import { Link } from "react-router";
import Dialog from "rc-dialog";
import DatePicker from "react-datepicker";
import moment from "moment";
import axios from "axios";
import Select from "react-select";
import FormErrorHandler from "../../../components/FormErrorHandler";
import { scrollToElem, getCountryData } from "../../../functions.js";
import { ELEARNING_WEEKS_DEFAULT } from "../../../constants";
import { data } from "autoprefixer";
import { hasStaffRole } from "../../../utils/auth";

export default class EventTemplate extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            dateStart: props.eventDetails && props.eventDetails.start_datetime ? moment(props.eventDetails.start_datetime) : null,
            timeFromHours: props.eventDetails && props.eventDetails.start_datetime ? moment(props.eventDetails.start_datetime).format("HH") : "--",
            timeFromMinutes: props.eventDetails && props.eventDetails.start_datetime ? moment(props.eventDetails.start_datetime).format("mm") : "--",
            timeToHours: props.eventDetails && props.eventDetails.end_datetime ? moment(props.eventDetails.end_datetime).format("HH") : "--",
            timeToMinutes: props.eventDetails && props.eventDetails.end_datetime ? moment(props.eventDetails.end_datetime).format("mm") : "--",
            instructors: props.eventDetails?.event_roles?.[0]?.instructors || [],
            auditor: props.eventDetails?.event_roles?.[0]?.auditor?.uuid,
            location: props.eventDetails ? props.eventDetails.location : "",
            template: props.templateUUID,
            course: props.courseUUID,
            trainer: props.trainerUUID,
            editable: props.editable ? props.editable : true,
            errorMessage: "",
            errorMessageLocation: "",
            availableInstructors: [],
            availableAuditors: [],
            newLocationDialogVisible: false,
            newLocationData: {
                company: this.props.trainerUUID,
                country: "NL"
            },
            competenceprofile: {},
            dataProvinces: [],
            stateChanged: false,
            selectedTimeFrom: false,
            selectedTimeTo: false
        };
    }

    updateElementState = (e) => {
        if (["timeFromHours", "timeFromMinutes"].includes(e.target.name)) {
            this.setState({
                selectedTimeFrom: true
            });
        }
        if (["timeToHours", "timeToMinutes"].includes(e.target.name)) {
            this.setState({
                selectedTimeTo: true
            });
        }

        if (e.target.name === "location" && e.target.value === "newlocation") {
            this.setState({
                newLocationDialogVisible: true
            });
        } else {
            this.setState({
                [e.target.name]: e.target.value
            });

            this.checkTimes();

            setTimeout(() => {
                this.passValuesToParent({
                    ...this.state
                });
            }, 200);
        }
    };

    checkTimes = () => {
        // Check if this is time related, if so, check that endtime is not before start time
        if (this.state.timeFromHours > this.state.timeToHours) {
            // Start time is bigger then endtime
            this.setState({
                timeToHours: this.state.timeFromHours,
                timeToMinutes: this.state.timeFromMinutes,
                selectedTimeFrom: true,
                selectedTimeTo: true
            });
        }
        if (this.state.timeFromHours === this.state.timeToHours) {
            if (this.state.timeFromMinutes > this.state.timeToMinutes) {
                this.setState({
                    timeToMinutes: this.state.timeFromMinutes,
                    selectedTimeFrom: true,
                    selectedTimeTo: true
                });
            }
        }
    };

    updateLocationElementState = (e) => {
        this.setState({
            newLocationData: {
                ...this.state.newLocationData,
                [e.target.name]: e.target.value
            }
        });

        if (e.target.name === "country") {
            this.getProvinces(e.target.value);
        }
    };

    handleDateChange = (date) => {
        this.setState({
            dateStart: date,
            stateChanged: true
        });
        this.passValuesToParent({
            ...this.state,
            dateStart: date
        });
    };

    createLocation = () => {
        let postData = {
            ...this.state.newLocationData
        };
        axios
            .post("/v1/locations/", postData)
            .then((response) => {
                this.setState({
                    location: response.data.uuid,
                    newLocationDialogVisible: false,
                    newLocationData: {
                        company: this.props.trainerUUID,
                        country: "NL"
                    }
                });
                this.passValuesToParent({
                    ...this.state,
                    location: response.data.uuid
                });
            })
            .catch((error) => {
                this.setState({
                    errorMessageLocation: error.response.data
                });
            });
    };

    handleOptionsChange = (val, stateName) => {
        if (Array.isArray(val)) {
            this.setState({
                [stateName]: val.map((option) => {
                    return { uuid: option.value };
                })
            });
        } else {
            this.setState({
                [stateName]: val ? val.value : null
            });
        }

        const instructors = stateName === "instructors" ? val : this.state.instructors;
        const auditor = stateName === "auditor" ? val?.value : this.state.auditor;

        this.passValuesToParent({
            ...this.state,
            auditor: auditor ? { uuid: auditor } : null,
            event_roles: [
                {
                    template: this.props.templateDetails.roles[0].uuid,
                    instructors: instructors.map((i) => {
                        return { uuid: i.value ? i.value : i.uuid };
                    })
                }
            ]
        });
    };

    passValuesToParent = (values) => {
        let instructors = [];
        if (values.event_roles && values.event_roles[0].instructors) {
            values.event_roles[0].instructors.forEach((instr) => {
                if (instr.uuid) {
                    instructors.push({ uuid: instr.uuid });
                } else {
                    instructors.push({ uuid: instr });
                }
            });
        } else {
            this.state.instructors.forEach((instr) => {
                instructors.push({ uuid: instr.uuid });
            });
        }

        const ret = {
            uuid: this.props.eventDetails ? this.props.eventDetails.uuid : null,
            trainer: values.trainer,
            course: values.course,
            location: values.location,
            start_datetime: values.dateStart
                ? moment(values.dateStart).format("YYYY-MM-DD") +
                  "T" +
                  (values.timeFromHours === "--" ? "00" : values.timeFromHours) +
                  ":" +
                  (values.timeFromMinutes === "--" ? "00" : values.timeFromMinutes) +
                  ":00"
                : null,
            end_datetime: values.dateStart
                ? moment(values.dateStart).format("YYYY-MM-DD") +
                  "T" +
                  (values.timeToHours === "--" ? "00" : values.timeToHours) +
                  ":" +
                  (values.timeToMinutes === "--" ? "00" : values.timeToMinutes) +
                  ":00"
                : null,
            template: values.template,
            event_roles: [
                {
                    template: this.props.templateDetails.roles[0].uuid,
                    instructors
                }
            ]
        };

        // Only set this property if we are allowed to set it:
        if (this.canSetAuditor()) {
            ret.event_roles[0].auditor = values.auditor;
        }

        this.props.passValuesToParent(ret);
    };

    componentDidUpdate = () => {
        if (this.props.defaultDate !== null && this.state.dateStart === null) {
            this.setState({
                dateStart: moment(this.props.defaultDate)
            });
        }
        if (this.state.timeFromHours > this.state.timeToHours) {
            this.setState({
                timeToHours: this.state.timeFromHours
            });
        }
        if (this.state.timeFromHours === this.state.timeToHours) {
            if (this.state.timeFromMinutes > this.state.timeToMinutes) {
                this.setState({
                    timeToMinutes: this.state.timeFromMinutes
                });
            }
        }
        if (this.props.editable !== this.state.editable && typeof this.props.editable !== "undefined") {
            this.setState({
                editable: this.props.editable
            });
        }
    };

    canSetAuditor = () => {
        return hasStaffRole(this.props.authentication?.user?.roles);
    };

    componentDidMount = () => {
        if (this.props.cpUUID !== "" && this.props.companyUUID !== "") {
            axios
                .get(
                    "/v1/competenceprofiles/" +
                        this.props.competenceProfileUUID +
                        "/eventtemplates/" +
                        this.props.templateDetails.uuid +
                        "/instructors/?fields=uuid,first_name,last_name_prefix,last_name,is_active,full_name&pagination=false&trainer=" +
                        this.state.trainer
                )
                .then((instructors) => {
                    this.setState({
                        availableInstructors: instructors.data
                    });
                })
                .catch((error) => {
                    console.log(error);
                });

            if (this.canSetAuditor()) {
                axios
                    .get("/v1/users/", {
                        params: {
                            roles: "auditor",
                            pagination: "false",
                            fields: "uuid,full_name"
                        }
                    })
                    .then((auditors) => {
                        this.setState({ availableAuditors: auditors.data });
                    });
            }
        }

        if (this.props.competenceProfileUUID) {
            axios
                .get("/v1/competenceprofiles/" + this.props.competenceProfileUUID + "/")
                .then((cp) => {
                    this.setState({
                        competenceprofile: cp.data
                    });
                })
                .catch((error) => {
                    console.log(error);
                });
        }

        if (this.state.dateStart == null && this.props.defaultDate && this.props.defaultDate !== null) {
            this.setState({
                dateStart: moment(this.props.defaultDate)
            });
        }

        this.getProvinces();
    };

    getProvinces = (country = this.state.newLocationData.country) => {
        axios
            .get(`/v1/states/?country=${country}`)
            .then((provinces) => {
                this.setState({
                    dataProvinces: provinces.data.results
                });
            })
            .catch((error) => {
                console.log(error);
            });
    };

    render() {
        const isNew = !this.props.eventDetails?.uuid;
        // updated in this.updateElementState()
        const selectedTimeFrom = this.state.selectedTimeFrom || (!isNew && !!this.props?.eventDetails?.start_datetime);
        const selectedTimeTo = this.state.selectedTimeTo || (!isNew && !!this.props?.eventDetails?.end_datetime);

        let timeHours =
            this.props?.eventDetails?.start_datetime && selectedTimeFrom
                ? []
                : [
                      <option value={""} key={"-"}>
                          {"--"}
                      </option>
                  ];
        let timeToHours =
            this.props?.eventDetails?.end_datetime && selectedTimeTo
                ? []
                : [
                      <option value={""} key={"-"}>
                          {"--"}
                      </option>
                  ];
        let timeMinutes =
            this.props?.eventDetails?.start_datetime && selectedTimeFrom
                ? []
                : [
                      <option value={""} key={"-"}>
                          {"--"}
                      </option>
                  ];
        let timeToMinutes =
            this.props?.eventDetails?.start_datetime && selectedTimeTo
                ? []
                : [
                      <option value={""} key={"-"}>
                          {"--"}
                      </option>
                  ];

        // When an elearning template is present, we need to transpose the start date to <provided> weeks later (now 4, previously 6)
        const hasElearning = this.props.eventTemplates.some((o) => o.type === "elearning");
        const transposeWeeks = hasElearning ? (this.props?.elearningWeeks ? parseInt(this.props.elearningWeeks) : ELEARNING_WEEKS_DEFAULT) : 0;

        // if the competenceprofile contains a min_date (a starting moment in time from where this competence profile can be
        // planned, we should modify the minDate for the select component. We treat it as a not-yet existing var so it will
        // fallback to the default which is 'now'
        const now = moment();
        const minDate = this.state.competenceprofile?.min_date ? moment(this.state.competenceprofile.min_date).add(transposeWeeks, "weeks") : now;
        const maxDate = this.state.competenceprofile?.max_date ? moment(this.state.competenceprofile.max_date) : null;

        for (var i = 0; i < 24; i++) {
            let timeValue = String(i).padStart(2, "0");
            timeHours.push(
                <option key={timeValue} value={timeValue}>
                    {timeValue}
                </option>
            );
            if (i >= parseInt(this.state.timeFromHours)) {
                timeToHours.push(
                    <option key={timeValue} value={timeValue}>
                        {timeValue}
                    </option>
                );
            }
        }
        for (var i = 0; i < 60; i += 1) {
            let timeValue = String(i).padStart(2, "0");
            timeMinutes.push(
                <option key={timeValue} value={timeValue}>
                    {timeValue}
                </option>
            );
            if (this.state.timeFromHours === this.state.timeToHours) {
                // you might want to consider using i > x instead if i >= x as a course event of 0 minutes is somewhat strange
                // however it might be deliberate, so kept it at i >= x
                if (i >= this.state.timeFromMinutes || this.state.timeFromMinutes === "--") {
                    timeToMinutes.push(
                        <option key={timeValue} value={timeValue}>
                            {timeValue}
                        </option>
                    );
                }
            } else {
                timeToMinutes.push(
                    <option key={timeValue} value={timeValue}>
                        {timeValue}
                    </option>
                );
            }
        }

        let countries = [];
        let countryData = getCountryData();
        Object.entries(countryData).forEach(([country, value]) => {
            countries.push(
                <option value={country} key={`country-${country}`}>
                    {countryData[country]}
                </option>
            );
        });

        let provinces = [];
        provinces.push(
            <option value="" key="new-province">
                Kies een provincie
            </option>
        );
        this.state.dataProvinces.forEach((prov) => {
            provinces.push(
                <option value={prov.uuid} key={`prov-${prov.state}`}>
                    {prov.name}
                </option>
            );
        });

        let availableInstructors = [];
        this.state.availableInstructors.forEach((instructor) => {
            if (instructor.is_active) {
                availableInstructors.push({
                    value: instructor.uuid,
                    label: instructor.full_name,
                    disabled: !instructor.is_active
                });
            }
        });

        const availableAuditors = this.state.availableAuditors.map((auditor) => {
            return {
                value: auditor.uuid,
                label: auditor.full_name
            };
        });

        let availableLocations = [];
        if (!this.state.location) {
            availableLocations.push(
                <option value="" key="0">
                    Kies een locatie
                </option>
            );
        }
        this.props.availableLocations.forEach((location) => {
            availableLocations.push(
                <option value={location.uuid} key={location.uuid}>
                    {location.name}
                </option>
            );
        });

        availableLocations.push(
            <option value="newlocation" key="newlocation">
                - Nieuwe locatie aanmaken
            </option>
        );

        // If the parent is in splittedEvents, do not show the big title here
        let title = [];
        let child = false;
        let childCounter = this.props.childCounter || 1;

        let prerequiredEvent = null;
        let prerequiredContent = false;
        if (this.props.templateDetails.prerequisites != "") {
            prerequiredEvent = this.props.eventTemplates.find((item) => this.props.templateDetails.prerequisites.includes(item.uuid));

            if (prerequiredEvent) {
                prerequiredContent = <h2 className="h3">Dit toetsmoment is afhankelijk van '{prerequiredEvent.name}'</h2>;
            }
        }

        if (this.props.hideTitle !== true) {
            if (this.props.splittedEvents && !this.props.splittedEvents.find((item) => item === this.props.templateUUID) && this.props.templateDetails.parent === null) {
                let hasChildren = this.props.eventTemplates.find((item) => item.parent === this.props.templateDetails.uuid);

                title.push(
                    <div className="col-12" key="title">
                        <h2 className="h1">{this.props.templateDetails.name}</h2>
                        {prerequiredContent}
                        {hasChildren ? (
                            <div className="sublink" onClick={() => this.props.toggleSplittedEvent(this.props.templateUUID)}>
                                Dit toetsmoment (met verschillende eindtermen) splitsen
                            </div>
                        ) : (
                            ""
                        )}
                    </div>
                );
            } else {
                child = true;
                title.push(
                    <div className="col-12" key="title">
                        {childCounter === 1 ? <h2 className="h1">{this.props.parentData.name}</h2> : ""}
                        {childCounter === 1 ? (
                            <div className="sublink" onClick={() => this.props.toggleSplittedEvent(this.props.parentData.uuid)}>
                                Dit toetsmomenten (met verschillende eindtermen) samenvoegen
                            </div>
                        ) : (
                            ""
                        )}
                    </div>
                );
            }
        }

        let startDate = this.state.dateStart;

        let infoNotice = [];
        let checkDate = moment(startDate).subtract(5, "days");
        if (moment(startDate) < now && this.state.editable) {
            infoNotice.push(
                <div className="col-12" key="warning-1">
                    <div className="alert alert-danger">De datum van dit toetsmoment ligt in het verleden</div>
                </div>
            );
        }

        // minDate !== now added because the minDate falls back to moment() (instead of null) when no min_date is set.
        // This way we make sure that when no min_date is set, the warning is not displayed. It would probably be better
        // if we handle this better, but as it is a customer issue, speed is important
        if (this.state.editable && ((!!minDate && moment(startDate) < minDate && minDate !== now) || (!!maxDate && moment(startDate) > maxDate))) {
            infoNotice.push(
                <div className="col-12" key="warning-1">
                    <div className="alert alert-danger">De datum van dit toetsmoment valt niet binnen de toegestane periode voor dit competentieprofiel</div>
                </div>
            );
        }

        // Check if it is within 5 days
        else if (checkDate < now && this.state.editable) {
            if (!this.props.eventDetails || this.state.stateChanged === true) {
                infoNotice.push(
                    <div className="col-12" key="warning-2">
                        <div className="alert alert-info">Omdat het toetsmoment binnen 5 dagen begint, worden er extra kosten in rekening gebracht.</div>
                    </div>
                );
            }
        }

        // Check if this moment is still editable
        if (!this.state.editable) {
            infoNotice.push(
                <div className="col-12" key="warning-3">
                    <div className="alert alert-warning">Dit toetsmoment kan niet langer worden bewerkt</div>
                </div>
            );
        }

        // Check how many instructors we have for the total amount of students
        let instructorCount = this.state.instructors.length || 0;
        let studentsCount = 0;
        let studentCheckCount = this.state.competenceprofile.max_students_per_instructor || 0;

        if (this.props.eventDetails && this.props.eventDetails.event_roles[0] && this.props.eventDetails.event_roles[0].students) {
            studentsCount = this.props.eventDetails.event_roles[0].students.length;
        }

        let studentInstructorLimit = false;
        if (studentCheckCount * instructorCount < studentsCount && this.state.editable) {
            studentInstructorLimit = (
                <div className="col-12">
                    <div className="alert alert-warning">Op basis van het aantal cursisten zijn er mogelijk meerdere instructeurs nodig</div>
                </div>
            );
        }

        let currentTrainer = "";
        let currentTrainerObject = this.props.allTrainersData.find((item) => item.uuid === this.props.trainerUUID);
        if (currentTrainerObject) {
            currentTrainer = currentTrainerObject.name;
        }

        let downloadExamsNotice = false;
        if (this.props.eventDetails && this.props.eventDetails.type && this.props.eventDetails.type === "knowledge-exam") {
            downloadExamsNotice = (
                <div className="col-12">
                    <div className="alert alert-info">
                        De examens voor dit toetsmoment kun je vinden onder <Link to={`/courses/edit/${this.props.courseUUID}/downloads`}>Downloads</Link>
                    </div>
                </div>
            );
        }
        const isNIBHVUser = hasStaffRole(this.props.authentication?.user?.roles || []);

        return (
            <div>
                <div className="row">
                    {title}
                    {child ? (
                        <h3 className="col-12">
                            <strong>
                                {childCounter}. {this.props.templateDetails.name}
                            </strong>
                        </h3>
                    ) : (
                        ""
                    )}
                    {child ? <div className="col-12">{prerequiredContent}</div> : false}
                    {infoNotice.map((o, idx) => {
                        return <React.Fragment key={idx}>{o}</React.Fragment>;
                    })}
                    {studentInstructorLimit}
                    {downloadExamsNotice}
                    <div className="col-6">
                        <div className="form-group">
                            <label>Datum *</label>
                            <DatePicker
                                name="dateStart"
                                customInput={<input type="text" className="form-control" onClick={this.props.onClick} {...this.props.value} />}
                                onChange={this.handleDateChange}
                                onKeyDown={(event) => {
                                    let value = event.target.value;
                                    if (event.keyCode == 9 && value.length < 6) {
                                        let splittedValue = value.split("-");
                                        let day = splittedValue[0];
                                        let month = splittedValue[1];
                                        let year = moment().format("YYYY");
                                        this.handleDateChange(moment(year + "-" + month + "-" + day));
                                    }
                                }}
                                onChangeRaw={(event) => {
                                    let value = event.target.value.split("-").join("");
                                    let newDate = value.substring(0, 2);
                                    if (value.length >= 3) {
                                        newDate += "-" + value.substring(2, 4);
                                    }
                                    if (value.length >= 5) {
                                        let checkYear = value.substring(4, 8);
                                        if (checkYear.length == 2 && checkYear != "19" && checkYear != "20") {
                                            newDate += "-19" + value.substring(4, 8);
                                        } else {
                                            newDate += "-" + value.substring(4, 8);
                                        }
                                    }
                                    event.target.value = newDate;
                                }}
                                selected={startDate}
                                className="form-control"
                                required={true}
                                placeholderText="Kies de datum"
                                autoComplete="off"
                                disabled={!this.state.editable}
                                minDate={minDate}
                                maxDate={maxDate}
                            />
                        </div>
                    </div>
                    <div className="col-3">
                        <div className="form-group">
                            <label>Van *</label>
                            <div className="input-group">
                                <select
                                    required
                                    name="timeFromHours"
                                    className="form-control from-control-md"
                                    onChange={this.updateElementState}
                                    value={this.state.timeFromHours}
                                    disabled={!this.state.editable}
                                >
                                    {timeHours}
                                </select>
                                <select
                                    required
                                    name="timeFromMinutes"
                                    className="form-control from-control-md"
                                    onChange={this.updateElementState}
                                    value={this.state.timeFromMinutes}
                                    disabled={!this.state.editable}
                                >
                                    {timeMinutes}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="col-3">
                        <div className="form-group">
                            <label>Tot *</label>
                            <div className="input-group">
                                <select
                                    required
                                    name="timeToHours"
                                    className="form-control from-control-md"
                                    onChange={this.updateElementState}
                                    value={this.state.timeToHours}
                                    disabled={!this.state.editable}
                                >
                                    {timeToHours}
                                </select>
                                <select
                                    required
                                    name="timeToMinutes"
                                    className="form-control from-control-md"
                                    onChange={this.updateElementState}
                                    value={this.state.timeToMinutes}
                                    disabled={!this.state.editable}
                                >
                                    {timeToMinutes}
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <div className="form-group">
                            <label>Locatie *</label>
                            <select
                                name="location"
                                className="form-control form-control-md"
                                onChange={this.updateElementState}
                                required={true}
                                value={this.state.location}
                                disabled={!this.state.editable}
                            >
                                {availableLocations}
                            </select>
                            <FormErrorHandler fieldName="location" errorObject={this.state.errorMessage.event_roles} />
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="form-group">
                            <label>Instructeur(s)</label>
                            <Select
                                {...window.selectDefaults}
                                key={`multiselect-${this.props.title}`}
                                name="instructors"
                                value={this.state.instructors.map((instr) => {
                                    return instr.uuid;
                                })}
                                optionRenderer={(option) => (
                                    <div>
                                        {option.label} {option.disabled && <span className="badge badge-warning">Inactief</span>}
                                    </div>
                                )}
                                options={availableInstructors}
                                className="full-width-labels"
                                onChange={(values) => this.handleOptionsChange(values, "instructors")}
                                multi={true}
                                placeholder="Leeglaten om later te bepalen"
                                disabled={isNIBHVUser ? false : !this.state.editable ? true : false}
                            />
                            <FormErrorHandler fieldName="instructor" errorObject={this.state.errorMessage.event_roles} />
                        </div>

                        {/* In function component, use the useCurrentUser() hook: */}
                        {this.canSetAuditor() && (
                            <div className="form-group">
                                <label>Controleur</label>
                                <Select
                                    {...window.selectDefaults}
                                    name="auditor"
                                    value={this.state.auditor}
                                    options={availableAuditors}
                                    className="full-width-labels controller-dropdown"
                                    onChange={(value) => this.handleOptionsChange(value, "auditor")}
                                    multi={false}
                                    clearable={true}
                                    placeholder="Leeglaten om geen controleur te selecteren"
                                    disabled={!this.state.editable}
                                />
                                <FormErrorHandler fieldName="auditor" errorObject={this.state.errorMessage.event_roles} />
                            </div>
                        )}
                    </div>
                </div>

                <Dialog
                    title={"Nieuwe locatie aanmaken"}
                    onClose={() => this.setState({ newLocationDialogVisible: false })}
                    visible={this.state.newLocationDialogVisible}
                    className="smaller"
                    footer={[
                        <button type="button" className="btn btn-primary" key="create" onClick={this.createLocation}>
                            Aanmaken
                        </button>
                    ]}
                >
                    <form onSubmit={this.createLocation}>
                        <div className="row">
                            <div className="col-12">
                                <div className="form-group">
                                    <label>Opleider *</label>
                                    <input name="trainer" disabled className="form-control form-control-md" value={currentTrainer} />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <div className="form-group">
                                    <label>Naam van de locatie*</label>
                                    <input
                                        type="name"
                                        tabIndex="2"
                                        name="name"
                                        ref="name"
                                        className="form-control form-control-md"
                                        required={true}
                                        onChange={this.updateLocationElementState}
                                        value={this.state.newLocationData.name || ""}
                                    />
                                    <FormErrorHandler fieldName="name" errorObject={this.state.errorMessageLocation} />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-8">
                                <div className="form-group">
                                    <label>Straatnaam *</label>
                                    <input
                                        type="street_name"
                                        tabIndex="3"
                                        name="street_name"
                                        ref="street_name"
                                        className="form-control form-control-md"
                                        required={true}
                                        onChange={this.updateLocationElementState}
                                        value={this.state.newLocationData.street_name || ""}
                                    />
                                    <FormErrorHandler fieldName="street_name" errorObject={this.state.errorMessageLocation} />
                                </div>
                            </div>
                            <div className="col-4">
                                <div className="form-group">
                                    <label>Huisnummer *</label>
                                    <input
                                        type="text"
                                        tabIndex="4"
                                        name="number"
                                        ref="number"
                                        className="form-control form-control-md"
                                        required={true}
                                        onChange={this.updateLocationElementState}
                                        value={this.state.newLocationData.number || ""}
                                    />
                                    <FormErrorHandler fieldName="number" errorObject={this.state.errorMessageLocation} />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-4">
                                <div className="form-group">
                                    <label>Postcode *</label>
                                    <input
                                        type="postal_code"
                                        tabIndex="5"
                                        name="postal_code"
                                        ref="postal_code"
                                        className="form-control form-control-md"
                                        required={true}
                                        onChange={this.updateLocationElementState}
                                        value={this.state.newLocationData.postal_code || ""}
                                    />
                                    <FormErrorHandler fieldName="postal_code" errorObject={this.state.errorMessageLocation} />
                                </div>
                            </div>
                            <div className="col-8">
                                <div className="form-group">
                                    <label>Plaatsnaam *</label>
                                    <input
                                        type="city"
                                        tabIndex="6"
                                        name="city"
                                        ref="city"
                                        className="form-control form-control-md"
                                        required={true}
                                        onChange={this.updateLocationElementState}
                                        value={this.state.newLocationData.city || ""}
                                    />
                                    <FormErrorHandler fieldName="city" errorObject={this.state.errorMessageLocation} />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-6">
                                <div className="form-group">
                                    <label>Land *</label>
                                    <select
                                        name="country"
                                        ref="country"
                                        className="form-control form-control-md"
                                        required={true}
                                        onChange={this.updateLocationElementState}
                                        value={this.state.newLocationData.country || ""}
                                    >
                                        {countries}
                                    </select>
                                    <FormErrorHandler fieldName="country" errorObject={this.state.errorMessageLocation} />
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="form-group">
                                    <label>Provincie *</label>
                                    <select
                                        name="state"
                                        ref="state"
                                        className="form-control form-control-md"
                                        required={true}
                                        onChange={this.updateLocationElementState}
                                        value={this.state.newLocationData.state || ""}
                                    >
                                        {provinces}
                                    </select>
                                    <FormErrorHandler fieldName="state" errorObject={this.state.errorMessageLocation} />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-6">
                                <div className="form-group">
                                    <label>Telefoonnummer *</label>
                                    <input
                                        type="phone_number"
                                        tabIndex="7"
                                        name="phone_number"
                                        ref="phone_number"
                                        className="form-control form-control-md"
                                        required={true}
                                        onChange={this.updateLocationElementState}
                                        value={this.state.newLocationData.phone_number || ""}
                                    />
                                    <FormErrorHandler fieldName="phone_number" errorObject={this.state.errorMessageLocation} />
                                </div>
                            </div>
                        </div>
                    </form>
                </Dialog>
            </div>
        );
    }
}
